
import { Component, Prop } from 'vue-property-decorator';
import VFormBuilder from '../shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';
import StackedForm from '../../mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { Article } from '@/interfaces/models/Article';

@Component({
  components: { VFormBuilder },
})
export default class AddonForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  @Prop({ type: Array, required: true }) public articles!: Article[];
  @Prop({ type: Boolean, required: true }) public isMaster!: boolean;

  get items() {
    return [
      {
        name: 'article',
        type: InputType.Autocomplete,
        label: 'upsell.form.article',
        rules: 'required',
        multiple: false,
        items: this.articleItems,
      },
    ];
  }

  get articleItems() {
    return this.articles.map((a: Article) => {
      return {
        value: this.isMaster && a.masterId ? a.masterId : a._id,
        text: `${this.$options.filters!.localized(a.name)} (${a.number})`,
      };
    });
  }
}
